import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { useRef } from "react";

export const ActionDetailSource = ({ items }: { items: any }) => {
  const menu = useRef<Menu>(null);

  return (
    <>
      <Menu model={items} popup ref={menu} className="tiered-menu-custom" />
      <Button
        icon={PrimeIcons.ELLIPSIS_V}
        text
        className="meatball"
        onClick={(e) => {
          e.stopPropagation();
          menu.current!.toggle(e);
        }}
      />
    </>
  );
};
